export enum SessionStorageKeyTypes {
  reviewPopupClosedByUser = 'reviewPopupClosedByUser',
  eventQueue = 'eventQueue',
}

export enum SessionStorageValueTypes {
  closed = 'closed',
}
